import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { StepButtons, StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import {
    fetchSeveralProgramSurveys,
    submitProgramSurvey,
} from 'src/modules/programs/surveys/actions/surveysActions';
import { GenericSurveyAnswer } from 'src/modules/programs/surveys/models/surveys';
import {
    getProgramSurveyAnswers,
    isProgramSurveyAnswered,
} from 'src/modules/programs/surveys/selectors/surveysSelectors';

import { ProsAndConsTab } from '../components/ProsAndConsTab';
import { CBTProgramWeekTwoSurvey } from '../models/weekTwo';

const goalsSurveyId = CBTProgramWeekTwoSurvey.WhatAreYourGoals;
const surveyId = CBTProgramWeekTwoSurvey.ProsAndCons;

interface StateProps {
    goalsAnswers: GenericSurveyAnswer[] | undefined;
    answers: GenericSurveyAnswer[] | undefined;
    isSurveyAnswered: boolean;
}

interface ActionsProps {
    fetchSeveralProgramSurveys: typeof fetchSeveralProgramSurveys;
    submitProgramSurvey: typeof submitProgramSurvey;
}

interface Props extends StepButtonsProps, StateProps, ActionsProps, WithTranslation {
    programId: ProgramEnum;
}

class ProsAndConsStepContainer extends React.Component<Props> {
    public componentDidMount(): void {
        const { programId } = this.props;

        this.props.fetchSeveralProgramSurveys({
            programId,
            surveysIds: [goalsSurveyId, surveyId],
        });
    }

    private handleSubmit = () => {
        const { programId, answers, goToNextStep } = this.props;

        if (!answers) {
            return;
        }

        this.props.submitProgramSurvey({
            programId,
            surveyId,
            answers,
        });

        goToNextStep();
    };

    public render(): JSX.Element {
        const { programId, isSurveyAnswered, goToPreviousStep, t } = this.props;

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn>
                        <S.StepHeading>{t('week-2.pros-and-cons.heading')}</S.StepHeading>
                        <ProsAndConsTab
                            programId={programId}
                            surveyId={surveyId}
                            makingChangeHeading={t('week-2.pros-and-cons.makingChangeHeading')}
                            stayingSameHeading={t('week-2.pros-and-cons.stayingSameHeading')}
                        />
                    </S.ContentColumn>
                </S.ContentRow>
                <StepButtons
                    onPreviousClick={goToPreviousStep}
                    onNextClick={this.handleSubmit}
                    nextDisabled={!isSurveyAnswered}
                    hasNextStep
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId }: Props): StateProps => ({
    goalsAnswers: getProgramSurveyAnswers(state, programId, goalsSurveyId),
    answers: getProgramSurveyAnswers(state, programId, surveyId),
    isSurveyAnswered: isProgramSurveyAnswered(state, programId, surveyId),
});

export const ProsAndConsStep = withTranslation('cbt')(
    connect<StateProps, ActionsProps>(mapStateToProps, {
        fetchSeveralProgramSurveys,
        submitProgramSurvey,
    })(ProsAndConsStepContainer),
);
